import { Button, ButtonGroup } from "@mui/material"
import { useCallback, useEffect } from "react"
import { productKinds, ProductKind } from "~/proposals/models/product.model"
import { formatProductKind } from "~/proposals/proposal.utils"
import { useUiStore } from "~/ui/ui.use-ui-store.hook"

type Props = {
  onChange?: (kind: ProductKind) => void
  excludeProductKinds?: ProductKind[]
}

export function ProductMenu({
  onChange = () => {},
  excludeProductKinds = [],
}: Props) {
  const {
    state: { quickFilters },
    actions: { setQuickFilters },
  } = useUiStore()

  const handleChange = useCallback(
    (productKind: ProductKind) => {
      setQuickFilters({ ...quickFilters, productKind })
      onChange(productKind)
    },
    [quickFilters, onChange, setQuickFilters],
  )

  useEffect(() => {
    if (excludeProductKinds.includes(quickFilters.productKind)) {
      // For now, it's biogas but, generally we want to default to the first in list.
      handleChange(ProductKind.BIOGAS)
    }
  }, [handleChange, excludeProductKinds])

  const visibleProductKinds = productKinds.filter(
    (pk) => !excludeProductKinds.includes(pk),
  )

  return (
    <ButtonGroup>
      {visibleProductKinds.map((productKind) => (
        <Button
          key={productKind}
          value={productKind}
          onClick={() => handleChange(productKind)}
          variant={
            productKind === quickFilters.productKind ? "contained" : "outlined"
          }
        >
          {formatProductKind(productKind)}
        </Button>
      ))}
    </ButtonGroup>
  )
}
